<!-- eslint-disable -->
<template lang="pug">
    .page-container
        .payment-banner
            .payment-banner__current-place
                .payment-banner__image(:class="imageClass")
            .payment-banner__info
                .payment-banner__header
                    | {{ statusText }}
                .payment-banner__text
                    | {{ helpText }}
                    router-payment__link.payment__link(:to="{name: 'support'}" target="_blank")
                        | {{ $i18n.t('olympiads.olympiads_helpText_support') }}
                    | , {{ $i18n.t('olympiads.olympiads_helpText_mail') }}
                    | &nbsp;
                    a.payment__link(href="mailto:mental@cleverstart.ru")
                        | mental@cleverstart.ru
                    |.
                    | &nbsp;
                    span(v-if="$route.path.includes('olympiads') && result !== 'error'")
                        | {{ $i18n.t('olympiads.olympiads_helpText_notPay') }}
                .payment-banner__button
                    cs-button(
                        color="blue"
                        html-tag="router-payment__link"
                        :to="{name: 'dashboard'}"
                    )
                        | {{ $i18n.t('common.common_navigation_goToMain') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        computed: {
            result () {
                return this.$route.path.includes('success') ? 'successful' : 'error';
            },
            statusText () {
                return this.result === 'error'
                        ? this.$i18n.t('olympiads.olympiads_failure_statusText')
                        : this.$i18n.t('olympiads.olympiads_success_statusText');
            },
            helpText () {
                return this.result === 'error'
                        ? this.$i18n.t('olympiads.olympiads_failure_helpText')
                        : this.$i18n.t('olympiads.olympiads_success_helpText');

            },
            imageClass () {
                return this.result === 'error'
                    ? 'payment-banner__image_failure'
                    : 'payment-banner__image_success';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-container {
        padding: 0;
        background-color: $x-color-white;
        box-sizing: border-box;
        max-width: 600px;
        margin: 0 auto;
        @include media($sm) {
            padding: 15px;
            border-radius: 40px;
        }
    }

    .payment-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        transition: transform 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .payment-banner--animated {
        transform: scale(1.05, 1.05);
    }

    .payment-banner__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .payment-banner__text {
        margin-top: 10px;
        font-size: 16px;
        line-height: 24px;
    }

    .payment-banner__button {
        margin-top: 13px;
    }

    .payment-banner__current-place {
        margin: 30px auto;
        width: 220px;
        height: 220px;
        background-color: $x-color-white;
        border-radius: $border-radius-circle;
        overflow: hidden;
    }

    .payment-banner__image {
        background-repeat: no-repeat;
        height: 220px;
    }

    .payment-banner__image_failure {
        background-position: -55px 10px;
        background-image: url('../../../assets/images/FailureTurtle.png');
    }

    .payment-banner__image_success {
        background-position: center 10px;
        background-image: url('../../../assets/images/SuccessTurtle.png');
    }

    .payment-banner__info {
        margin: 0 30px 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .payment__link {
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }
</style>


